import type { Language } from './lib/types'

export const langCodeLocaleMap: Record<Language, string> = {
    cn: 'zh_CN',
    de: 'de_DE',
    en: 'en_US',
    es: 'es_ES',
    fr: 'fr_FR',
    it: 'it_IT',
    ja: 'ja_JP',
    ko: 'ko_KR',
    nl: 'nl_NL',
    pl: 'pl_PL',
    pt: 'pt_BR',
    ru: 'ru_RU',
    tr: 'tr_TR',
    tw: 'zh_TW',
}
